import { Col, Row, Card, Table, Alert } from "antd";
import React from "react";
import {
  getColumnsWithHighlight,
  orderRefChanges,
} from "../AllOrgActivities/helper";

export const OrderRefActivities = ({ data }) => {
  const renderModifiedGroup = (changes) => {
    if (!changes?.length) return null;

    const rows = changes.map((change, idx) => ({
      old: { ...change.old_values, key: `old-${idx}` },
      new: { ...change.new_values, key: `new-${idx}` },
    }));

    const oldValues = rows.map((r) => r.old);
    const newValues = rows.map((r) => r.new);
    const newColumns = getColumnsWithHighlight(
      orderRefChanges,
      oldValues,
      newValues
    );

    return (
      <div className="mb-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "16px" }}
        >
          Modified Entries
        </h4>
        <h5
          className="ant-typography ant-typography-sm font-medium mb-2"
          style={{ textAlign: "left", color: "#666", fontWeight: "bold" }}
        >
          Previous Values
        </h5>
        <div className="mb-4">
          <Card
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
          >
            <Table
              columns={orderRefChanges}
              dataSource={oldValues}
              pagination={false}
              bordered
            />
          </Card>
        </div>
        <h5
          className="ant-typography ant-typography-sm font-medium mb-2"
          style={{ textAlign: "left", color: "#666", fontWeight: "bold" }}
        >
          Updated Values
        </h5>
        <div>
          <Card
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
          >
            <Table
              columns={newColumns}
              dataSource={newValues}
              pagination={false}
              bordered
            />
          </Card>
        </div>
      </div>
    );
  };

  const fuelSurchargeData = data ? data : [];

  const renderFuelSurchargeMain = (data) => {
    return (
      <div className="mt-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "18px" }}
        >
          {
            data[0].customer_order_number && (
          <span style={{ fontSize: "20px", color: "#395484" }}>
            {`${"#"} ${data[0].customer_order_number}`}
          </span>
            )
          }
          <div className="mt-6">{renderModifiedGroup(data)}</div>
        </h4>
      </div>
    );
  };

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderFuelSurchargeMain(fuelSurchargeData)}</Col>
    </Row>
  );
};
